function locationNameToPlainText(value) {
  if (value == null || value === "") {
    return "";
  }
  const s = String(value);
  if (typeof document === "undefined") {
    return s.replace(/<[^>]+>/g, "");
  }
  const doc = new DOMParser().parseFromString(s, "text/html");
  return (doc.body?.textContent ?? "").trim();
}

const LocBlock = ({ loc }) => {
  return (
    <div className="flex relative flex-col flex-1 p-4 min-h-0 bg-white rounded-md loc-block">
      <div className="flex flex-col flex-1 gap-3 mb-3 min-h-0">
        <div className="flex flex-col gap-3 justify-between items-center text-xl font-bold location-title md:flex-row">
          <span className="flex gap-2 items-center">
            <img
              src={loc.pin}
              alt="brand"
              width={25}
              className="mx-auto mb-0 w-5"
            />
            {loc.brand === "G-FORCE" && `G-FORCE® `}
            {loc.brand === "FIELD OPS" && `FIELD OPS® `}
            {(loc.brand === "PROP WASH" || loc.brand === "PROP WASH®") &&
              `PROP WASH® `}
            {locationNameToPlainText(loc.name)}
          </span>
          <span className="text-xs text-center text-gray-500 min-w-[45px]">
            {loc.distance} Mi
          </span>
        </div>
        <a
          className="block text-[#356fb1] underline text-center md:!text-left"
          href={`tel:${loc.phone}`}
        >
          {loc.phone}
        </a>
      </div>
      <a
        href={loc.url + "?ref=vsb-locator"}
        className="bg-white text-[#174082] inline-block py-2 px-4 mt-auto text-center text-sm font-semibold rounded shrink-0 w-full transition-all duration-200 uppercase border-t-2 border-r-2 border-b-2 border-l-4 border-[#174082] hover:!bg-[#174082] hover:text-white"
      >
        Visit Website
      </a>
    </div>
  );
};

export default LocBlock;
